<template>
  <div>
    <div>
      <div v-if="loaded && companyBanners.length === 0">
        <div class="alert alert-primary" role="alert">
          بنری یافت نشد، برای افزودن بنر
          <router-link
            :to="{ name: 'company-banners-create' }"
            class="alert-link text-light-primary"
          >
            کلیک
          </router-link>
          کنید
        </div>
      </div>
    </div>

    <div
      v-if="loaded && companyBanners.length"
      class="card card-custom gutter-b"
    >
      <div class="card-body">
        <div class="table-responsive">
          <table
            class="table table-head-custom table-head-bg table-borderless table-vertical-center"
          >
            <thead>
              <tr>
                <th>عنوان</th>
                <th>عرض</th>
                <th>تاریخ ساخت</th>
                <th>تاریخ بروزرسانی</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="banner in companyBanners" :key="banner.id">
                <td>{{ banner.title }}</td>
                <td>{{ banner.width }}</td>
                <td>{{ formatDate(banner.created_at) }}</td>
                <td>{{ formatDate(banner.updated_at) }}</td>
                <td class="text-nowrap">
                  <button
                    class="btn btn-xs btn-outline-danger mr-1"
                    @click="destroy(banner.id)"
                  >
                    <i class="flaticon2-trash"></i>
                    حذف
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div
      class="overflow-auto mt-5"
      v-if="companyBannersPagination.lastPage > 1"
    >
      <b-pagination
        v-model="companyBannersPagination.currentPage"
        :total-rows="companyBannersPagination.total"
        :per-page="companyBannersPagination.perPage"
        aria-controls="my-table"
        @input="getBanners()"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import {
  FETCH_COMPANY_BANNERS,
  DESTROY_COMPANY_BANNER
} from "@/core/services/store/company/banners.module";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "company-banners-index",
  data() {
    return {
      loaded: false
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.currentUserProperty.title ?? "داشبورد شرکت" },
      { title: "بنر‌‌ها" }
    ]);

    this.$store.dispatch(SET_ACTIONS, {
      links: [
        {
          name: '<i class="flaticon2-plus"></i>افزودن',
          to: { name: "company-banners-create" },
          class: "btn-primary"
        }
      ]
    });
    this.getBanners();
  },
  computed: {
    ...mapGetters(["companyBanners", "companyBannersPagination"])
  },
  methods: {
    isStopped(program) {
      return program.events.length;
    },
    getBanners() {
      this.loaded = false;
      this.$store
        .dispatch(FETCH_COMPANY_BANNERS)
        .then(() => {
          this.loaded = true;
        })
        .catch(() => {
          this.loaded = true;
        });
    },
    destroy(id) {
      Swal.fire({
        title: "",
        text: "آیا از حذف بنر‌ اطمینان دارید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "بله",
        confirmButtonColor: "#4554a0",
        cancelButtonText: "خیر",
        cancelButtonColor: "#ed1c24",
        heightAuto: false
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch(DESTROY_COMPANY_BANNER, id).then(() => {
            this.getBanners();
          });
        }
      });
    }
  }
};
</script>
